import { css } from 'react-emotion'

const styles = {
  leftSideBar: css({
    backgroundColor: '#f6f2ff !important',
  }),
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/SideBarsStyles.js